module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon-发布-发帖子.ba5c2.png";